// Common
import $ from 'jquery';
import ReactDOM from 'react-dom';
import CampList from '../../../components/filter_desktop/camp_list.js.jsx';
import CampListLoading from '../../../components/filter_desktop/camp_list_loading.js.jsx';
import MTFilterDesktop from '../../../components/filter_desktop/filter_desktop.js';
import FilterHeader from '../../../components/filter_desktop/filter_header.js.jsx';
import { DefaultDatesRangeContext } from '../../../components/filter_desktop/lib/default_dates_range_context';
import { SearchDataPopup } from '../../../components/filter_desktop/ui/search_data_popup';
import FilterTagsList from '../../../components/filter_tags_list.js';
import MapDesktop from '../../../components/map_desktop.js.jsx';
import SanatoriumsFilterAside from '../filter_aside/filter_aside.js.jsx';
import { getDefaultDatesRange } from './lib/get_default_dates_range';

export default class FilterDesktop extends MTFilterDesktop {
  /** Select фильтра лечения в виджете поиска */
  deceaseSelect;

  constructor(props) {
    super(props);
    this.state.filter_params = this.props.filter_params;
    this.filterAsideClassName = this.filterAsideClassName.bind(this);
    this.setDescending = this.setDescending.bind(this);
  }

  setDescending(type, allowReverse) {
    this.descending = allowReverse;
  }

  filterAsideClassName() {
    let className = 'aside';
    if (this.state.mapCampsLoaded && !this.state.listShowMode) className += ' aside-fixed';
    if (this.state.showingInitialCamps) className += ' card-loader disabling-loader';
    return className;
  }

  filter(filters, callback) {
    if (
      !Array.isArray(filters.campTreatmentProfiles) ||
      !filters.campTreatmentProfiles.includes(this.$deceaseSelect.val())
    ) {
      document.dispatchEvent(new CustomEvent('clear_chosen_treatment'));
    }
    super.filter(filters, callback);
  }

  componentDidMount() {
    this.$deceaseSelect = $('#camp_treatment_profiles');
    super.componentDidMount();
  }

  render() {
    let map;
    if (!this.state.listShowMode) {
      map = <MapDesktop {...this.mapProps()} showManagerMap={this.state.s_params.our_stuff} />;
    }

    const price_max_end = this.priceMaxEnd();

    let campList;
    if (this.state.campsLoaded && this.state.listShowMode && !this.state.showingInitialCamps) {
      if (this.state.camps.length > 0) {
        campList = (
          <div>
            <CampList
              camps={this.state.camps}
              showMapCamp={this.showMap}
              showContractPercent={this.state.s_params.our_stuff}
              showCommission={this.state.s_params.our_stuff}
              river={this.props.river}
              region_work_with={this.props.region_work_with}
              display_calculated_price={this.props.region_work_with || this.props.river_contracted_camp_exist}
              filter_params={this.state.filter_params}
              show_ads={this.state.filter_params.show_ads}
              show_transfer={this.props.show_transfer_block}
              count_guests={this.state.s_params.count_guests}
              children_ages={this.state.s_params.children_ages}
              fewerCountGuests={this.fewerCountGuests}
              delta_days={this.state.s_params.delta_days}
              filters={this.state.filters}
              campsLoaded={this.state.campsLoaded}
              showingInitialCamps={this.state.showingInitialCamps}
              style={{ display: this.state.listShowMode ? 'block' : 'none' }}
              filter_values={this.props.filter_values}
              favorites={this.state.favorites}
              toggleFavoriteCamp={this.toggleFavoriteCamp}
            />
            {!this.state.campsLoadingMore && !this.state.lastPageLoaded && (
              <div className={'pagination__item'} onClick={this.loadMore}>
                Показать еще
              </div>
            )}
          </div>
        );
      } else if (this.state.loadError) {
        campList = this.errorOutput();
      } else if (!this.state.campsLoadingMore) {
        campList = this.emptyOutput(price_max_end);
      }
    } else if (!this.state.campsLoaded && this.state.listShowMode) {
      campList = <CampListLoading camps_count={this.pageSize} />;
    }

    let filterOutput = undefined;
    if (this.state.campsLoaded && this.state.campsLoadingMore) {
      filterOutput = (
        <div>
          {campList}
          <div style={{ marginBottom: 22 }} />
          <CampListLoading camps_count={5} />
          {map}
        </div>
      );
    } else if (!this.state.campsLoaded && this.campsLoadingError) {
      filterOutput = <div className='text_center'>При загрузке санаториев произошла ошибка</div>;
    } else {
      filterOutput = (
        <div>
          {campList}
          {map}
        </div>
      );
    }

    let showAds;

    const adsPlaceholder = document.getElementById('ads-placeholder');
    const total_guests_count = this.state.s_params.count_guests + this.state.s_params.children_ages.length;

    return (
      <div className='container'>
        <div className='row' id='filter_content'>
          <div className='col-3'>
            <div className={this.filterAsideClassName()}>
              <SanatoriumsFilterAside
                price_max_end={price_max_end}
                filter={this.filter}
                data={this.state.filter_params}
                html_params={this.state.html_params}
                filters_counts={
                  this.state.listShowMode
                    ? (this.state.html_params?.filters_counts ?? {})
                    : (this.state.map_html_params?.filters_counts ?? {})
                }
                filters={this.state.filters}
                datesChosen={this.state.datesChosen}
                initPrices={this.state.initPrices}
                count_guests={this.state.s_params.count_guests}
                total_guests_count={total_guests_count}
                campsLoaded={this.state.campsLoaded && !this.state.showingInitialCamps}
                camps={this.state.camps}
                distanceInteraction={this.distanceInteraction}
                distanceToSkiLiftInteraction={this.distanceToSkiLiftInteraction}
                is_foreign={this.props.is_foreign}
                displaySkiLiftRange={this.props.displaySkiLiftRange}
                showManagerMap={this.state.s_params.our_stuff}
                listShowMode={this.state.listShowMode}
                filter_values={this.props.filter_values}
                user_show_filter={this.state.user_show_filter}
              />
            </div>
          </div>

          <div className='col-9'>
            <div className='founded-camps'>
              <FilterTagsList
                price_max_end={this.priceMaxEnd()}
                filters={this.state.filters}
                data={this.state.filter_params}
                filter={this.filter}
                campsLoaded={this.state.campsLoaded && !this.state.showingInitialCamps}
                resetFilter={this.resetFilter}
                is_desktop={true}
                user_show_filter={this.state.user_show_filter}
              />
              <FilterHeader
                urlStr={this.state.s_params.url_str}
                region={this.state.filter_params.region}
                city={this.state.filter_params.city}
                city_name_genitive={this.state.filter_params.city_name_genitive}
                city_seo_path={this.state.filter_params.city_seo_path}
                river={this.props.river}
                region_work_with={this.props.region_work_with}
                sort={this.sort}
                sort_type={this.state.sort}
                descending={this.descending}
                total={this.state.camps.length}
                pageNum={this.state.pageNum}
                pageSize={this.pageSize}
                showMap={this.showMap}
                showList={this.showList}
                listShowMode={this.state.listShowMode}
                show_ads={this.state.filter_params.show_ads}
                campsLoaded={this.state.campsLoaded && !this.state.showingInitialCamps}
                dateRangeNotifierForSanatoriums={this.props.date_range_notifier_for_sanatoriums}
                is_district={this.state.filter_params.is_district}
              />

              {filterOutput}

              <div id='loading-map' className='loading-map hidden'>
                <div className='load-icon loading__img loading-map__img'></div>
                Загрузка...
              </div>
            </div>
          </div>
        </div>

        {adsPlaceholder && ReactDOM.createPortal(showAds, adsPlaceholder)}
        {this.seoMapOpened && (
          <DefaultDatesRangeContext.Provider value={getDefaultDatesRange()}>
            <SearchDataPopup
              title={this.props.seo_h1}
              mapOpened={!this.state.listShowMode}
              onSubmit={this.handleSubmitSearchDataPopup}
            />
          </DefaultDatesRangeContext.Provider>
        )}
      </div>
    );
  }
}
